export default {
  data() {
    return {
      dialsContactsFields: [
        {
          key: 'name',
          sortable: true,
          visible: true
        },
        {
          key: 'dials',
          sortable: true,
          visible: true,
          tdClass: 'align-middle'
        },
        {
          key: 'contacts',
          sortable: true,
          visible: true,
          tdClass: 'align-middle'
        },
        {
          key: 'conversion',
          sortable: true,
          visible: true,
          tdClass: 'align-middle'
        },
        {
          key: 'ratio',
          sortable: true,
          visible: false,
          tdClass: 'align-middle'
        }
      ],
      listingApptsSetFields: [
        {
          key: 'name',
          sortable: true,
          visible: true
        }, 
        {
          key: 'contacts',
          sortable: true,
          visible: true,
          tdClass: 'align-middle'
        },
        {
          key: 'listings_set',
          sortable: true,
          visible: true,
          tdClass: 'align-middle'
        },
        {
          key: 'conversion',
          sortable: true,
          visible: true,
          tdClass: 'align-middle'
        },
        {
          key: 'ratio',
          sortable: true,
          visible: false,
          tdClass: 'align-middle'
        }
      ],
      buyerApptsSetFields: [
        {
          key: 'name',
          sortable: true,
          visible: true
        },
        {
          key: 'contacts',
          sortable: true,
          visible: true,
          tdClass: 'align-middle'
        },
        {
          key: 'buyers_set',
          sortable: true,
          visible: true,
          tdClass: 'align-middle'
        },
        {
          key: 'conversion',
          sortable: true,
          visible: true,
          tdClass: 'align-middle'
        },
        {
          key: 'ratio',
          sortable: true,
          visible: false,
          tdClass: 'align-middle'
        }
      ],
      listingsSetHeldFields: [
        {
          key: 'name',
          sortable: true,
          visible: true
        },
        {
          key: 'listings_set',
          sortable: true,
          visible: true,
          tdClass: 'align-middle'
        },
        {
          key: 'listings_held',
          sortable: true,
          visible: true,
          tdClass: 'align-middle'
        },
        {
          key: 'conversion',
          sortable: true,
          visible: true,
          tdClass: 'align-middle'
        },
        {
          key: 'ratio',
          sortable: true,
          visible: false,
          tdClass: 'align-middle'
        }
      ],
      buyersSetHeldFields: [
        {
          key: 'name',
          sortable: true,
          visible: true
        },
        {
          key: 'buyers_set',
          sortable: true,
          visible: true,
          tdClass: 'align-middle'
        },
        {
          key: 'buyers_held',
          sortable: true,
          visible: true,
          tdClass: 'align-middle'
        }, 
        {
          key: 'conversion',
          sortable: true,
          visible: true,
          tdClass: 'align-middle'
        },
        {
          key: 'ratio',
          sortable: true,
          visible: false,
          tdClass: 'align-middle'
        }
      ],
      listingsHeldTakenFields: [
        {
          key: 'name',
          sortable: true,
          visible: true
        }, 
        {
          key: 'listings_held',
          sortable: true,
          visible: true,
          tdClass: 'align-middle'
        }, 
        {
          key: 'listings_taken',
          sortable: true,
          visible: true,
          tdClass: 'align-middle'
        }, 
        {
          key: 'conversion',
          sortable: true,
          visible: true,
          tdClass: 'align-middle'
        }, 
        {
          key: 'ratio',
          sortable: true,
          visible: false,
          tdClass: 'align-middle'
        }
      ],
      buyersHeldSignedFields: [
        {
          key: 'name',
          sortable: true,
          visible: true
        },
        {
          key: 'buyers_held',
          sortable: true,
          visible: true,
          tdClass: 'align-middle'
        },
        {
          key: 'buyers_signed',
          sortable: true,
          visible: true,
          tdClass: 'align-middle'
        },
        {
          key: 'conversion',
          sortable: true,
          visible: true,
          tdClass: 'align-middle'
        },
        {
          key: 'ratio',
          sortable: true,
          visible: false,
          tdClass: 'align-middle'
        }
      ],
      listingsTakenSoldFields: [
        {
          key: 'name',
          sortable: true,
          visible: true
        },
        {
          key: 'listings_taken',
          sortable: true,
          visible: true,
          tdClass: 'align-middle'
        },
        {
          key: 'listings_sold',
          label: 'Listings Pended',
          sortable: true,
          visible: true,
          tdClass: 'align-middle'
        },
        {
          key: 'conversion',
          sortable: true,
          visible: true,
          tdClass: 'align-middle'
        },
        {
          key: 'ratio',
          sortable: true,
          visible: false,
          tdClass: 'align-middle'
        }
      ],
      buyersSignedSoldFields: [
        {
          key: 'name',
          sortable: true,
          visible: true
        },
        {
          key: 'buyers_signed',
          sortable: true,
          visible: true,
          tdClass: 'align-middle'
        },
        {
          key: 'buyers_sold',
          label: 'Buyers Pended',
          sortable: true,
          visible: true,
          tdClass: 'align-middle'
        },
        {
          key: 'conversion',
          sortable: true,
          visible: true,
          tdClass: 'align-middle'
        },
        {
          key: 'ratio',
          sortable: true,
          visible: false,
          tdClass: 'align-middle'
        }
      ]
    }
  }
}